import React, { useEffect, useState, useRef } from 'react';

/**
 * Slash-Menü das beim "/" im Input-Feld aufploppt.
 * - Filter nach getipptem Buchstaben
 * - Pfeil-Tasten / Enter / Escape via parent
 * - Klick → onSelect(commandTemplate)
 *
 * Commands sind Frontend-only Mapping zu Backend-Tool-Calls + spezialen Aktionen.
 */
// Phase 8 Cleanup: 7 → 4 Tools. status/service/logs/system sind unter `/ops` zusammengefasst.
export const SLASH_COMMANDS = [
  { trigger: 'web',      tool: 'web_search',   param: 'query',   placeholder: 'Suchbegriff', label: 'Web-Suche', desc: 'DDG / SearXNG (echte Treffer)', icon: '🌐' },
  { trigger: 'memory',   tool: 'memory_search',param: 'query',   placeholder: 'Stichwort',   label: 'Memory durchsuchen', desc: 'Findet Stichworte in deiner persönlichen Memory.md', icon: '📚' },
  { trigger: 'ops',      special: 'ops',       param: 'sub',     placeholder: '[logs <name> | service <name> | system | leer=Status]', label: 'Server-Ops', desc: 'Status / Service-Check / Logs / System-Info — 4-in-1', icon: '⚡' },
  { trigger: 'schedule', special: 'job', param: 'topic', placeholder: 'Recherche-Thema',     label: 'Recherche-Job', desc: 'Aus Chat einen wiederkehrenden Job erstellen', icon: '◷' },
];

export default function SlashMenu({ filter, onSelect, onClose }) {
  const [activeIdx, setActiveIdx] = useState(0);
  const containerRef = useRef(null);

  // Filter nach Trigger-Prefix (case-insensitive)
  const visible = SLASH_COMMANDS.filter(c =>
    !filter || c.trigger.startsWith(filter.toLowerCase())
  );

  useEffect(() => {
    if (activeIdx >= visible.length) setActiveIdx(0);
  }, [visible.length, activeIdx]);

  // Keyboard-Handling: Pfeile + Enter + Escape
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'ArrowDown') { e.preventDefault(); setActiveIdx(i => (i + 1) % visible.length); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActiveIdx(i => (i - 1 + visible.length) % visible.length); }
      else if (e.key === 'Tab' || e.key === 'Enter') {
        if (visible[activeIdx]) { e.preventDefault(); onSelect(visible[activeIdx]); }
      }
      else if (e.key === 'Escape') { e.preventDefault(); onClose(); }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [visible, activeIdx, onSelect, onClose]);

  if (visible.length === 0) {
    return (
      <div className="slash-menu" ref={containerRef}>
        <div className="slash-menu-empty">Keine Treffer für „/{filter}"</div>
      </div>
    );
  }

  return (
    <div className="slash-menu" ref={containerRef}>
      <div className="slash-menu-header">Befehle</div>
      {visible.map((c, i) => (
        <button
          key={c.trigger}
          className={`slash-item ${i === activeIdx ? 'active' : ''}`}
          onMouseEnter={() => setActiveIdx(i)}
          onClick={() => onSelect(c)}
          title={`/${c.trigger} — ${c.desc}`}
        >
          <span className="slash-icon">{c.icon}</span>
          <div className="slash-text">
            <div className="slash-label"><span className="slash-trigger">/{c.trigger}</span> {c.label}</div>
            <div className="slash-desc">{c.desc}</div>
          </div>
          {c.param && <span className="slash-arg">{c.placeholder}</span>}
        </button>
      ))}
    </div>
  );
}
